<template>
  <div class="page-dev">
    <div style="display: flex">
      <div style="width: 250px;margin-left: 0px; ">
        <el-input
          placeholder="输入关键字进行过滤"
          v-model="filterText">
        </el-input>
        <el-tree
          :data="treeData"
          :props="defaultProps"
          default-expand-all
          :filter-node-method="filterNode"
          @node-click="handleNodeClick"
          ref="tree">
        </el-tree>
      </div>
      <div style="flex: 1; margin: 16px; ">
        <div>
          <el-form :inline="true" ref="form2" @submit.native.prevent>
            <el-form-item>
              <el-input v-model="param.name" maxlength="200" style="width: 200px" @keyup.native.enter="list"></el-input>
              <el-button type="primary" @click="list">查询</el-button>
              <el-button type="primary" @click="random">随机</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-table :data="tableData" ref="dataTable">
            <el-table-column type="index" label="序号" width="50"/>
            <el-table-column prop="word" label="单词" width="200" show-overflow-tooltip/>
            <el-table-column prop="remark" label="备注" show-overflow-tooltip/>
            <el-table-column label="操作" width="320" align="center">
              <template slot-scope="scope">
                <!-- https://www.youdao.com/result?word=class&lang=en -->
                <el-link type="success" :href="'https://www.youdao.com/result?word=' + scope.row.word + '&lang=en'" target="_blank">有道词典</el-link>
                <!-- http://www.iciba.com/word?w=guess -->
                <el-link type="success" :href="'http://www.iciba.com/word?w=' + scope.row.word + ''" target="_blank">金山词霸</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as http from '../api/http'
import global from '../components/Global'

export default {
  name: 'Words',
  data () {
    return {
      filterText: '',
      typeId: 0,
      treeData: [],
      tableData: [],
      param: {name: null},
      form: {},
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  created () {
    this.getType()
  },
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val)
    }
  },
  methods: {
    filterNode (value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    handleNodeClick (data) {
      this.typeId = data.id
      this.changeType()
    },
    // handleSet (row) {
    //   // <!-- https://www.youdao.com/result?word=class&lang=en -->
    //   this.form = JSON.parse(JSON.stringify(row))
    //   let url = 'www.youdao.com/result?word=' + row.word + '&lang=en'
    //   let path = window.location.protocol + '//' + url
    //   window.location.href = path
    // },
    changeType () {
      if (this.typeId > 0) {
        this.param.name = null
        this.tableData = []
        http.post(global.url0 + 'primary_school/get/', {type: this.typeId}).then(
          res => {
            let resStr = res.toString
            if (resStr.length > 0 && !String.startsWith(resStr, '[')) {
              // this.$message.error(res)
              return
            }
            // console.log(res)
            this.tableData = res
          }
        )
      }
    },
    getType () {
      this.treeData = []
      http.post(global.url0 + 'word_type/get/', null).then(
        res => {
          // console.log(res)
          this.typeData = res
          res.forEach((item, index) => {
            let node = {id: item.id, label: item.name, children: []}
            if (item.parent === 0) {
              this.treeData.push(node)
            } else {
              for (var i = 0; i < this.treeData.length; i++) {
                let item2 = this.treeData[i]
                if (item2.id === item.parent) {
                  item2.children.push(node)
                  break // foreach not break, change to for
                }
              }
            }
          })
        }
      )
    },
    list () {
      if (this.param.name === undefined || this.param.name === null) {
        this.$message.error('请输入查询条件。')
        return
      }
      this.tableData = []
      http.post(global.url0 + 'primary_school/like/', this.param).then(
        res => {
          let resStr = res.toString
          if (resStr.length > 0 && !String.startsWith(resStr, '[')) {
            this.$message.error(res)
            return
          }
          // console.log(res)
          this.tableData = res
        }
      )
    },
    random () {
      this.tableData = []
      http.post(global.url0 + 'primary_school/random/', null).then(
        res => {
          let resStr = res.toString
          if (resStr.length > 0 && !String.startsWith(resStr, '[')) {
            this.$message.error(res)
            return
          }
          // console.log(res)
          this.tableData = res
        }
      )
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
page-div {
  width: 1000px;
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/views/Words.vue